// @flow

import React, { Component } from 'react';
import $ from 'jquery';
import _ from 'lodash';
import localforage from 'localforage';
import mapSeries from 'async/mapSeries';

import App from './App.jsx';
import Shp from './Shp.js';
import Img from './Img.js';
import FourMaps from './FourMaps.jsx';

import {takeDir, takeExtension, takeFilename, culti_regex, noop} from './utils.js';

import type {T_LL, T_Next, T_Point, T_RowEspecieCR} from './types.js';

// FIXME: IMPORTA LAS DEFINICIONES DE TIPO DE GOOGLE MAPS DESDE:
// https://github.com/jonboiser/flowtype-google-maps/blob/master/flow-typed/google-maps.js

import './css/Map.css';

const GoogleMapsLoader = require('google-maps');



type T_MapProps = {
  num       : number,
  name      : string,
  on_click  : (i: number) => void,                             // se usa en app.map_clicked y four_maps.activate_map
  on_img?   : (path: string, loaded: boolean, next: T_Next) => void,
  map_bts   : boolean,
  escala_for: string,
  width?    : number,
  height?   : number,
  full_size?: boolean,
  map_border: boolean,
  four_maps : ?FourMaps;
  app       : App
};


export type T_MapConfig = {
  tipo  : string,
  zoom  : number,
  center: T_LL
};



export default class Map extends Component<T_MapProps> {
  static vec2LL          = null;
  static google          = null;
  static map_opt         = null;
  static MarkerWithLabel = null;

  Shp_List: { [string]: Shp };
  Img_List: { [string]: Img };    // NOTE: NO SETEAR DIRECTAMENTE ESTA PROPIEDAD. USAR: notify_img_loaded

  map: Object;

  bypass_on_view_port: boolean;

  center_and_zoom     : (min_bound: T_Point, max_bound: T_Point , be_lazy?: boolean) => ?Object;
  center_and_zoom_path: (path: string, bypass_fix_zoom?: boolean) => ?Object;



  constructor(props: T_MapProps) {
    super(props);

    this.Shp_List = {};
    this.Img_List = {};

    this.bypass_on_view_port = false;

    this.center_and_zoom_path = this.center_and_zoom_path.bind(this);
    this.center_and_zoom      = this.center_and_zoom.bind(this);
  }



  notify_img_loaded(path: string, img: ?Img): void {
    if (img != null) {
      this.Img_List[path] = img;
    }
    else {
      delete this.Img_List[path];
    }

    if (this.props.on_img != null && _.isFunction(this.props.on_img)) {
      this.props.on_img(path, img != null, noop);
    }
  }



  destroy(): void {
    const ss = [],
          is = [];

    _.each(this.Shp_List, (xx: Shp) => {
      ss.push(xx.obj.shpfile);

      xx.destroy(this);
    });

    _.each(this.Img_List, (xx: Img) => {
      is.push(xx.obj.img_filepath);

      xx.destroy();
    });

    ss.forEach((path) => {
      delete this.Shp_List[path];
    });

    is.forEach((path) => {
      delete this.Img_List[path];
    });

    $(`#${this.get_id()}`).empty();
  }



  get_google_maps_lib(): ?Object {
    return Map.google;
  }



  componentDidMount() {
    const setup = () => {
      if (Map.google != null) {
        const google_maps = Map.google,
              map_opt     = _.cloneDeep(Map.map_opt);

        if (map_opt != null && ! this.props.map_bts) {
          map_opt.disableDefaultUI = true;
        }

        this.map = new google_maps.Map(document.getElementById(this.get_id()), map_opt);
        this.props.app.map_ui.map = this;
        this.fix_resize();

        if (this.props.name) {
          this.props.app.ready(this.props.name);
        }

        if (_.isFunction(this.props.on_click)) {
          google_maps.event.addListener(this.map, 'click', ev => this.props.on_click(this.props.num));
        }

        this.map.addListener('maptypeid_changed', () => {
          const map_type = this.map.getMapTypeId();

          if (map_type === 'terrain' || map_type === 'roadmap') {
            this.set_shp_border({strokeColor: 'black'});
          }
          else if (map_type === 'hybrid' || map_type === 'satellite') {
            this.set_shp_border({strokeColor: 'red'});
          }
        });

        if (this.props.four_maps != null) {
          this.props.four_maps.map_refs[this.props.num] = this;
        }
      }
    };

    if (Map.google === null) {
      GoogleMapsLoader.LIBRARIES = ['geometry', 'drawing'];
      GoogleMapsLoader.KEY = 'AIzaSyDIRJZdgAd8dDOe2jyziAxQOS9aY_zLH9U';

      GoogleMapsLoader.load((google) => {
        Map.google = google.maps;

        Map.map_opt = {
          zoom: 15,
          mapTypeId: Map.google.MapTypeId.ROADMAP,
          panControl: false,
          streetViewControl: false,
          zoomControlOptions: {
            style:    Map.google.ZoomControlStyle.SMALL,
            position: Map.google.ControlPosition.RIGHT_TOP
          },
          zoomControl: false,
          fullscreenControl: false,
          disableDefaultUI: false,
          mapTypeControlOptions: {
            style:    Map.google.MapTypeControlStyle.HORIZONTAL_BAR,
            position: Map.google.ControlPosition.TOP_RIGHT
          },
          draggable             : true,
          scrollwheel           : true,
          disableDoubleClickZoom: false
        };

        if (Map.google != null) {
          const google_maps = Map.google;

          Map.vec2LL = (xy: T_Point) => {
            return new google_maps.LatLng(xy[0], xy[1]);
          };
        }

        Map.MarkerWithLabel = require('markerwithlabel')(Map.google);
        setup();
      });
    }
    else {
      setup();
    }
  }



  set_ui(on: boolean): void {
    this.map.setOptions({
      disableDefaultUI: ! on
    });
  }



  set_interacion(on: boolean): void {
    this.map.setOptions({
      draggable             : on,
      scrollwheel           : on,
      disableDoubleClickZoom: on,
    });
  }



  set_zoom_controls(on: boolean): void {
    this.map.setOptions({zoomControl: on});
  }



  get_id(): string {
    return `div_map_${this.props.name}`.toLowerCase();
  }



  render() {
    let style = {};

    if (this.props.width  != null && typeof this.props.width  === 'number' && this.props.width  > 0 &&
        this.props.height != null && typeof this.props.height === 'number' && this.props.height > 0) {
      style = {
        style: {
          width : this.props.width,
          height: this.props.height,
          border: (this.props.map_border ? '15px solid red' : '')
        }
      };
    }

    if (this.props.full_size) {
      style = {
        style: {
          width : '100%',
          height: '100%',
          border: (this.props.map_border ? '1px solid lightgray' : '')
        }
      };
    }

    return (
      <div
        className='map'
        {...style}
        id={this.get_id()}
      />
    );
  }



  fix_resize(): void {
    if (Map.google != null) {
      Map.google.event.trigger(this.map, 'resize');
    }
  }



  center_and_zoom(min_bound: Array<number>, max_bound: Array<number>, be_lazy?: boolean): ?Object {
    if (Map.google != null) {
      const google_maps = Map.google,
            bounds = new google_maps.LatLngBounds(),
            ll_min = new google_maps.LatLng(min_bound[0], min_bound[1]);

      bounds.extend(ll_min);
      bounds.extend(new google_maps.LatLng(max_bound[0], max_bound[1]));

      if (! be_lazy) {
        if (! this.props.app.state.fix_zoom) {
          if (_.isEqual(min_bound, max_bound)) {
            this.map.setCenter(ll_min);
          }
          else {
            this.map.fitBounds(bounds);
          }
        }
      }

      return bounds;
    }
    else {
      return null;
    }
  };



  center_and_zoom_path(path: string, bypass_fix_zoom: boolean = false): ?Object {
    let bounds = null;

    if (_.has(this.Shp_List, path)) {
      bounds = this.Shp_List[path].bounds;    // eslint-disable-line prefer-destructuring
    }
    else if (_.has(this.Img_List, path)) {
      bounds = this.Img_List[path].bounds;    // eslint-disable-line prefer-destructuring
    }

    if (bounds && (bypass_fix_zoom || (! this.props.app.state.fix_zoom))) {
      this.map.fitBounds(bounds);
    }

    return bounds;
  }



  on_view_port(path: string): boolean {
    if (this.bypass_on_view_port) {
      return true;
    }

    let bounds = null;

    if (_.has(this.Shp_List, path)) {
      bounds = this.Shp_List[path].bounds;     // eslint-disable-line prefer-destructuring
    }
    else if (_.has(this.Img_List, path)) {
      bounds = this.Img_List[path].bounds;     // eslint-disable-line prefer-destructuring
    }

    if (! bounds) {
      return false;
    }

    const screen = this.map.getBounds();

    return screen.contains(bounds.getNorthEast()) && screen.contains(bounds.getSouthWest());
  }



  get_opened_polys(): Array<string> {
    return _.keys(this.Shp_List).filter(path => this.Shp_List[path].obj.shptype !== 'Point');
  }



  get_culti_of(dir: string): string {
    const cs = _.keys(this.Shp_List).filter((path) => {
      return takeFilename(path).indexOf('cultivable_') === 0 && takeDir(path) === dir;
    });

    if (cs.length > 0) {
      return cs[0];
    }
    else {
      return '';
    }
  }



  touch(path: string): void {   // el objeto referenciado por path se convierte ahora en el último visitado por el usuario
    if (! path) {
      return;
    }

    const is_shp = takeExtension(path) === 'shp';

    if (! this.is_loaded(path)) {
      return;
    }

    const collection = is_shp ? this.Shp_List : this.Img_List,
          max: number = _.maxBy(_.values(collection), (xx: Shp | Img) => xx.old).old;

    collection[path].old = max + 1;

    if (is_shp && takeFilename(path).match(culti_regex)) {
      localforage.setItem(`${this.props.app.state.user.user_name}.last_culti`, path);
    }
    else if (takeExtension(path) === 'png') {
      localforage.setItem(`${this.props.app.state.user.user_name}.last_png`, path);
    }
  }



  last_loaded(collection: {[string]: Object}, in_dir: ?string, only_culti: boolean = false): ?Object {
    let res: ?Object = null,
        old: number = -1000;

    const is_in_dir = (path) => {
      return _.isString(in_dir) ? takeDir(path) === in_dir : true;
    };

    const aditional_filter = (path) => {
      return only_culti ? takeFilename(path).match(culti_regex) : true;
    };

    for (const path in collection) {
      if (collection.hasOwnProperty(path)) {
        if (collection[path].old > old && is_in_dir(path) && aditional_filter(path)) {
          res = collection[path];
          old = collection[path].old;     // eslint-disable-line prefer-destructuring
        }
      }
    }

    return res;
  }



  last_img(in_dir: ?string): ?Img {
    return this.last_loaded(this.Img_List, in_dir);
  }



  last_shp(in_dir: ?string): ?Shp {
    return this.last_loaded(this.Shp_List, in_dir);
  }



  is_loaded(path: string): boolean {
    if (! path) {
      return false;
    }

    return _.has(this.Shp_List, path) || _.has(this.Img_List, path);
  }



  last_shp_path(in_dir: ?string): string {
    const shp = this.last_shp(in_dir);

    if (! shp) {
      return '';
    }

    return shp.obj.shpfile;
  }



  last_img_path(in_dir: ?string): string {
    const img = this.last_img(in_dir);

    if (! img) {
      return '';
    }

    return img.obj.img_filepath;
  }



  last_culti_path(): string {
    const shp = this.last_loaded(this.Shp_List, null, true);

    if (! shp) {
      return '';
    }

    return shp.obj.shpfile;
  }



  img_that_contains(ll: T_LL): ?string {
    const dir = takeDir(this.last_shp_path()),
          xs = _.filter(this.Img_List, xx => xx.overlay.getBounds().contains(ll) && takeDir(xx.obj.img_filepath) === dir);

    return xs.length === 0 ? null : xs[0].obj.img_filepath;
  }



  get_pol(path: string, id: number) {
    return _.has(this.Shp_List, path) ? _.find(this.Shp_List[path].overlays, pp => pp.ID === id) : null;
  }



  has_images_loaded(): boolean {
    return _.keys(this.Img_List).length > 0;
  }



  imgs_loaded(): Array<string> {
    return _.keys(this.Img_List);
  }



  things_loaded(): Array<string> {
    const rs = _.keys(this.Shp_List);

    rs.push(..._.keys(this.Img_List));

    return rs;
  }



  kill_these(paths: Array<string>, next: T_Next = noop): void {  // NOTE: cierra objetos solo en el mapa, no en el árbol
    mapSeries(paths, (path: string, callback) => {               // para cerrar en ambos, usar app.kill_these
      const ext = takeExtension(path);

      if (ext === 'png' && this.is_loaded(path)) {
        this.Img_List[path].destroy();
      }
      else if (ext === 'shp' && this.is_loaded(path)) {
        this.Shp_List[path].destroy(this);
      }

      callback(null, true);
    }, (err, rs) => next(true));
  }



  kill_all(next: T_Next = noop): void {
    this.kill_these(this.things_loaded(), next);
  }



  reload_ms_icons(): void {
    _.each(this.Shp_List, (val: Shp, key: string) => {
      if (val.obj.shptype === 'Point') {
        val.reload_icons();
      }
    });
  }



  set_shp_border(new_conf: Object): void {
    if (_.has(new_conf, 'strokeColor')) {
      Shp.border_color               = new_conf.strokeColor;
      Shp.polygonOptions.strokeColor = new_conf.strokeColor;
    }

    _.each(this.Shp_List, (val: Shp, key: string) => {
      if (val.obj.shptype === 'Polygon') {
        val.set_options(new_conf);
      }
    });
  }



  get_map_config(): T_MapConfig {
    const center = this.map.getCenter();

    return {
      tipo  : this.map.getMapTypeId(),
      zoom  : this.map.getZoom(),
      center: {
        lat: center.lat(),
        lng: center.lng()
      }
    };
  }



  put_marker(lat: number, lon: number, on_click: ?T_Next): ?Object {
    if (Map.google != null) {
      const google = Map.google;    // eslint-disable-line prefer-destructuring

      const marker = new google.Marker({
        position: new google.LatLng(lat, lon)
      });

      if (_.isFunction(on_click)) {
        marker.addListener('click', on_click);
      }

      marker.setMap(this.map);

      return marker;
    }

    return null;
  }



  fix_especies_of(path: string, rows: Array<T_RowEspecieCR>): void {
    const especies = rows.map(row => row.Especie);

    if (_.has(this.Shp_List, path)) {
      for (const dbf of this.Shp_List[path].obj.dbfRecords) {
        if (dbf.ESPECIE && typeof dbf.ESPECIE === 'string') {
          dbf.ESPECIE = dbf.ESPECIE.toLowerCase();

          if (! especies.includes(dbf.ESPECIE)) {
            for (const row of rows) {
              if (row.sinonimos.includes(dbf.ESPECIE)) {
                dbf.ESPECIE = row.Especie;
                break;
              }
            }
          }
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/Map.jsx